import $ from 'jquery';
import EdeeshopPopup from 'fg-frontend/plugins/edeeshop-popup/EdeeshopPopup';

// export to window
window.$ = $;
window.jQuery = $;

/**
 * Edeeshop Popup init
 */
window.edeeshopPopup = new EdeeshopPopup();

window.getQueryParams = () => {
  const hash = window.location.search.substr(1);

  return hash.split('&').reduce((result, item) => {
    var parts = item.split('=');
    result[parts[0]] = parts[1];
    return result;
  }, {});
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/windowExports.js